import { render, staticRenderFns } from "./AddCxr.vue?vue&type=template&id=48a60fbc&scoped=true&"
import script from "./AddCxr.vue?vue&type=script&lang=js&"
export * from "./AddCxr.vue?vue&type=script&lang=js&"
import style0 from "./AddCxr.vue?vue&type=style&index=0&id=48a60fbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a60fbc",
  null
  
)

export default component.exports